import { ICartItem } from 'screens/AccessExpressV3/CartProvider';
import { ReactComponent as BroadbandCartImage } from 'assets/images/broadband_cart_image.svg';
import { ReactComponent as StarlinkCartImage } from 'assets/images/starlink_cart_item.svg';
import { ReactComponent as DIACartImage } from 'assets/images/dia_cart_item.svg';
import ImagePlaceholder from '../ImagePlaceholder';

export const CartItemImage = ({ item }: { item: ICartItem }) => {
  const { item_details, subtype } = item;

  if (item_details?.image) {
    return (
      <img
        src={item_details.image}
        alt="Product"
        className="h-16 w-16 rounded object-contain"
      />
    );
  }

  switch (subtype) {
    case 'dia':
      return <DIACartImage />;
    case 'broadband':
      return <BroadbandCartImage />;
    case 'starlink':
      return <StarlinkCartImage />;
    default:
      return <ImagePlaceholder />;
  }
};
